import AddCustomFieldsInfoToPostEdit from "./AddCustomFieldsInfoToPostEdit";
import '../../scss/custom-fields-info.scss';

jQuery(document).ready(function () {
	const helper = new AddCustomFieldsInfoToPostEdit('postcustomstuff');
	helper.addInfoToElements();
	helper.observeNewElements();
});


// WEBPACK FOOTER //
// ./js/post-meta/app.js